// extracted by mini-css-extract-plugin
export default {"container":"styles_container__YWVqi","container__inner":"styles_container__inner__msKPk","img__container":"styles_img__container__SlqD7","ticker":"styles_ticker__Dfg7S"};